import { Box, CircularProgress } from '@material-ui/core';
import { CreateCSSProperties, createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { ReactComponent as AwaitingIcon } from '@/assets/icons/status-awaiting.svg';
import { ReactComponent as FailedIcon } from '@/assets/icons/status-failed.svg';
import { ReactComponent as SuccessIcon } from '@/assets/icons/status-success.svg';
import { makeSelectIsMobileView } from '@/model/global/selectors';

const useStyles = makeStyles(() => {
  const headerIconContainer: CreateCSSProperties = {
    zIndex: 2,
    position: 'absolute',
    alignSelf: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: 84,
    height: 84,
  };
  return createStyles({
    headerIconContainer: {
      ...headerIconContainer,
      marginTop: -42,
    },
    headerIconContainerMobile: {
      ...headerIconContainer,
      marginTop: -84,
    },
    progressIconContainer: {
      backgroundColor: '#302E4D',
      borderRadius: '50%',
    },
  });
});

export type Status = 'success' | 'failed' | 'awaiting' | 'progress' | 'info';

const selectIsMobile = makeSelectIsMobileView();

export interface HeaderIconProps {
  status: Status;
}

export const HeaderIcon: React.FC<HeaderIconProps> = ({ status }: HeaderIconProps) => {
  const classes = useStyles();
  const isMobile = useSelector(selectIsMobile);
  return (
    <Box
      className={clsx(
        isMobile ? classes.headerIconContainerMobile : classes.headerIconContainer,
        status === 'progress' && classes.progressIconContainer,
      )}
    >
      {status === 'success' && <SuccessIcon />}
      {status === 'failed' && <FailedIcon />}
      {status === 'awaiting' && <AwaitingIcon />}
      {status === 'progress' && (
        <CircularProgress
          thickness={4}
          size={48}
          variant="indeterminate"
          style={{
            color: 'white',
            marginTop: 18,
          }}
        />
      )}
    </Box>
  );
};

export default HeaderIcon;
